import * as React from "react";
import { UserState } from '../App';
import './Login.css';
import { AnonymizationList } from './FileList';

export interface LoginProps {
 onLoginSuccess: (state: UserState) => void,
 uploaded: boolean,
}

export interface LoginState {
  loginFailed?: string,
  loginId?: string,
  loginLocked: boolean,
  password?: string,
}

export class Login extends React.Component<LoginProps, LoginState> {
  constructor(props: LoginProps) {
    super(props);
    this.state = {
      loginFailed: '',
      loginId: '',
      loginLocked: false,
      password: '',
    };
  }


  public render() {

    return (
      <div className="Login">
        <h2>ログイン</h2>
        {this.state.loginLocked && this.loginTrying}
        {this.state.loginFailed && this.errMsg}
        <div className="Login-Form">
          <form id="login-form" onSubmit={this.handleSubmit}>
            <div>
              <label>ログインID </label>
              <input
                type="text"
                name="loginId"
                value={this.state.loginId}
                onChange={this.loginIdInputChange}
              />
            </div>
            <div>
              <label>パスワード </label>
              <input
                type="password"
                name="password"
                value={this.state.password}
                onChange={this.passwordInputChange}
              />
            </div>
            <div>
              <button
                className="hvr-grow"
                type="submit"
                disabled={this.state.loginLocked}
              >ログイン</button>
            </div>
          </form>
        </div>
        {this.uploaded ? this.uploadedMsg : null}
      </div>
    );
  }

  private loginIdInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ loginId: event.target.value as string });
  }

  private passwordInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ password: event.target.value as string });
  }

  private get loginParams() {
    const loginId = this.state.loginId;
    const password = this.state.password;
    return { loginId, password };
  }

  private lockLoginButtion() {
    this.setState({ loginLocked: true, loginFailed: '' });
  }

  private unlockLoginButton() {
    this.setState({ loginLocked: false });
  }

  private failLogin(errMsg: string) {
    this.unlockLoginButton();
    this.setState({ loginFailed: errMsg });
  }

  private get uploaded() {
    return this.props.uploaded && !this.state.loginLocked;
  }

  private get uploadedMsg() {
    return (
      <div className="UploadedStatus">
        <div className={'Msg'}>下記のファイルをアップロードしました</div>
        <div>
          <div className="UploadedList Header">
            <div>ファイル名</div>
            <div>状態</div>
            <div>匿名化</div>
            <div>社/国</div>
            <div>調剤月</div>
          </div>
          {this.uploadedList}
        </div>
      </div>
    );
  }

  private get uploadedList() {
    // return (AnonymizationList as string);
    //var lists = ""
    return AnonymizationList.map((list, i) => {
        // どうせ部分的に差し替わったりしないから `key={i}` でも良い
        return (
        <div key={i} className="UploadedList">
          <div>{list.name}</div>
          <div className="status">{list.status}</div>
          <div>{list.isHashed ? '済' : '未'}</div>
          <div>{["", "社保", "国保"][Number(list.insureName)]}</div>
          <div>{list.prepareName}</div>
        </div>
        )
    });
  }

  private get errMsg() {
    return (
      <div className={'Err'}>
        ログインに失敗しました: {this.state.loginFailed}
      </div>
    );
  }

  private get loginTrying() {
    return <div className={'Msg'}>ログイン処理中です</div>;
  }

  private handleSubmit = (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault();
    if (this.state.loginId!.length > 0 && this.state.password!.length > 0) {
      this.lockLoginButtion();
      fetch('https://us-central1-irw-base.cloudfunctions.net/medi-trend-uploader-auth', {
        body: JSON.stringify(this.loginParams),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        method: 'POST',
        mode: 'cors',
      }).then(
        (res: Response) => res.ok ? res.json() : Promise.reject(res)
      ).catch(
        (res: Response) => {
          this.unlockLoginButton();
          this.failLogin(`status: ${res.status}`);
        }
      ).then(
        (user: UserState) => this.props.onLoginSuccess(user)
      )
    } else {
      window.alert('ログインIDとパスワードが必要です');
    }
  }
}
